export default {
  data () {
    return {
      msg: '',
      showTable: false,
      loading: false,
      importDialog: false,
      importTable: [],
      title: 'daoru',
      dialogTitle: '批量导入文件上传',
      importSelection: [],
      permissionOriginData: [],
      permissionData: [],
      submitLoading: false,
    }
  },
  methods: {
    beginUpload () {
      this.loading = true;
    },
    // 返回预览导入数据
    returnData (val) {
      this.loading = true;
      this.importTable = val;
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 添加导入明细
    sumbitTableData () {
      // 判断是否有不符合导入要求的数据
      if (this.importTable.length === 0) {
        this.$message.error('导入数据为空，请重新选择文件');
        this.$refs.import.loading = false;
        return;
      }
      if (this.importSelection.some(item => item.errorMsg)) {
        this.$message.error('所选数据包含错误数据，请重新选择');
        this.$refs.import.loading = false;
        return;
      }
      this.batchImport();
    },
    // 删除导入列表所选数据
    deleteImportData () {
      this.$confirm('确定删除选中数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.importTable = this.importTable.filter(
          item => !this.importSelection.includes(item),
        );
        this.importSelection = [];
        this.$refs.wxeTable.removeSelecteds();
      });
    },
    refreshData () {
      this.importDialog = false;
      this.importSelection = [];
      this.$emit('refresh');
    },
    clearImportData () {
      this.importTable = [];
      this.importSelection = [];
      this.$refs.import.remove();
    },
    importTableChange (val) {
      this.importSelection = val;
    },
    opened() {
      this.$refs.wxeTable.$refs.wxeTable.refreshColumn();
    }
  }
}